import "../../../../content/departments/media/performance.css";
import * as React from 'react';
export default {
  React
};